import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import ScaleArrowIcon from '~/pages/anatomyV2/rateYourself/libs/components/AnatomyV2RateYourself/ScaleArrowIcon'
import {
  RATE_YOURSELF_OPTIONS,
  RATE_YOURSELF_QUESTION,
  SECTION_NUMBER,
  rateYourselfPNG,
  rateYourselfWEBP,
} from '~/pages/anatomyV2/rateYourself/libs/components/AnatomyV2RateYourself/constants'
import { AnatomyV2RateYourselfStyles as S } from '~/pages/anatomyV2/rateYourself/libs/components/AnatomyV2RateYourself/styles'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const AnatomyV2RateYourself = ({ pageId, nextPagePath }: TPageProps) => {
  useMatchHeaderBackground()

  const { t } = useTranslation('anatomyV2')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: RATE_YOURSELF_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <SectionProgress currentSection={SECTION_NUMBER} pageId={pageId} />

        <S.Title>
          <Trans ns="anatomyV2" i18nKey="onboarding.rateYourself.title" />
        </S.Title>

        <picture>
          <source srcSet={rateYourselfWEBP} type="image/webp" />
          <S.Image src={rateYourselfPNG} alt="Human organs" />
        </picture>

        <S.RatingRow>
          {RATE_YOURSELF_OPTIONS.map((value) => (
            <S.RatingButton
              key={value}
              type="button"
              $isSelected={answer === value}
              disabled={isAnswersDisabled}
              onClick={() => {
                setAnswer(value)
                handleChange(value, handleContinue)
                setIsAnswersDisabled(true)
              }}
            >
              {value}
            </S.RatingButton>
          ))}
        </S.RatingRow>

        <S.ScaleRow>
          <S.ScaleLabel>{t('onboarding.rateYourself.basics')}</S.ScaleLabel>
          <S.ScaleLine>
            <ScaleArrowIcon />
          </S.ScaleLine>
          <S.ScaleLabel>{t('onboarding.rateYourself.expert')}</S.ScaleLabel>
        </S.ScaleRow>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default AnatomyV2RateYourself
